module.exports = __webpack_public_path__ + "assets/triangle-arrow-down.e0373e6f.svg";